module.exports = __webpack_public_path__ + "img/logo.155698ba.svg";